/**
 * Cart drawer: adding a product and clicking the cart icon open the drawer instead of
 * going to the cart page. Without JavaScript both still lead to the cart page.
 */
const cartDrawer = document.querySelector('[data-cart-drawer]');

if (cartDrawer) {
  const sectionId = cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');

  // Swaps in the freshly rendered drawer and brings the cart count in the header up to date.
  const render = (html) => {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
    if (!fresh) return false;
    cartDrawer.querySelector('[data-cart-drawer-content]').replaceWith(fresh);

    const count = Number(fresh.dataset.cartCount);
    document.querySelectorAll('[data-cart-count]:not([data-cart-drawer-content])').forEach((element) => {
      element.textContent = count;
      element.hidden = count === 0;
    });
    return true;
  };

  const post = async (url, body) => {
    const response = await fetch(`${url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    const cart = await response.json();
    if (!render(cart.sections?.[sectionId] ?? '')) throw new Error('Cart drawer was not rendered');
  };

  const open = () => {
    if (!cartDrawer.open) cartDrawer.showModal();
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches(`form[action$="${cartDrawer.dataset.cartAddUrl}"]`)) return;
    event.preventDefault();

    const body = new FormData(form);
    body.append('sections', sectionId);
    // If anything goes wrong, fall back to the normal form post and the cart page.
    post(cartDrawer.dataset.cartAddUrl, body)
      .then(open)
      .catch(() => form.submit());
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-toggle]')) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target === cartDrawer) {
      cartDrawer.close();
      return;
    }

    const button = event.target.closest('[data-cart-line]');
    if (!button) return;
    const body = new FormData();
    body.append('line', button.dataset.cartLine);
    body.append('quantity', button.dataset.cartQuantity);
    body.append('sections', sectionId);
    cartDrawer.classList.add('is-loading');
    post(cartDrawer.dataset.cartChangeUrl, body)
      .catch(() => window.location.reload())
      .finally(() => cartDrawer.classList.remove('is-loading'));
  });
}
